import React from 'react';
import { addOurStorageMaterialList, addOurStorageMaterialDelete } from '../../../../api/storage'
import PageList from '../../../../components/PageListAPI'
import { SLUGS } from 'src/enum/permissions.enum';
import { useCan } from 'src/hooks/useCan';

export default function SmaList(props) {
  const can = useCan()
  return <div className='App-paper'>
    <PageList
      name='SmaList'
      title='Добавить на склад'
      columns={[
        { id: 'id', name: '№', },
        { id: 'storageSpace', name: 'Склад', },
        { id: 'user', name: 'Добавил', },
        { id: 'dateAdd', name: 'Дата добавления', type: 'date' },
      ]}
      createItem={can(SLUGS.STORAGE.MATERIAL.ADD_MANAGE)}
      deleteItem={can(SLUGS.STORAGE.MATERIAL.ADD_MANAGE)}
      idName='id'
      history={props.history}
      match={props.match}
      location={props.location}
      loadAPI={{
        request: addOurStorageMaterialList,
      }}
      deleteAPI={addOurStorageMaterialDelete}
      headerInit={{
        sortBy: 'dateAdd',
        sortDirection: 'desc',
      }}
    />
  </div>
}